import { render, staticRenderFns } from "./H5Player.vue?vue&type=template&id=76a923a8&scoped=true"
import script from "./H5Player.vue?vue&type=script&lang=js"
export * from "./H5Player.vue?vue&type=script&lang=js"
import style0 from "./H5Player.vue?vue&type=style&index=0&id=76a923a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a923a8",
  null
  
)

export default component.exports